import { render, staticRenderFns } from "./header-navbar-language.vue?vue&type=template&id=3b81c08a&"
import script from "./header-navbar-language.vue?vue&type=script&lang=js&"
export * from "./header-navbar-language.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TritonPresentation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b81c08a')) {
      api.createRecord('3b81c08a', component.options)
    } else {
      api.reload('3b81c08a', component.options)
    }
    module.hot.accept("./header-navbar-language.vue?vue&type=template&id=3b81c08a&", function () {
      api.rerender('3b81c08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Scripts/app/components/header-bar/header-navbar-language.vue"
export default component.exports